import React, { useEffect, useRef, useState } from 'react';
import cx from 'classnames';
import styles from './Select.module.scss';
import Icon from '../../Icon/Icon';
import { useTranslation } from 'react-i18next';

const Select = ({ currentUser, data, onClick }) => {
  const [isActive, setIsActive] = useState(false);

  const selectRef = useRef(null);
  const optionsRef = useRef(null);

  const { t } = useTranslation();

  const handleToggle = () => {
    setIsActive(!isActive);
  };

  const handleClick = value => {
    onClick(value);
    setIsActive(false);
  };

  const handleClose = event => {
    if (optionsRef.current && !optionsRef.current.contains(event.target) && !selectRef.current.contains(event.target)) {
      setIsActive(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClose, true);
    return () => {
      document.removeEventListener('click', handleClose, true);
    };
  }, []);

  return (
    <>
      <div ref={selectRef} className={styles.selectMain} onClick={handleToggle}>
        {data.VIEWER.TYPE === currentUser.folderRole && <span>{t('folder.role.viewer.description')}</span>}
        {data.EDITOR.TYPE === currentUser.folderRole && <span>{t('folder.role.editor.description')}</span>}
        {isActive ? <Icon className={styles.arrowIcon} src="arrowUp" /> : <Icon className={styles.arrowIcon} src="arrowDown" />}
      </div>
      {isActive && (
        <div ref={optionsRef} className={styles.selectOptionsContainer}>
          {Object.values(data).map(({ TYPE }) => (
            <div
              key={TYPE}
              className={cx(styles.selectOption, { [styles.selectNotSelected]: TYPE !== currentUser.folderRole })}
              onClick={() => handleClick({ email: currentUser.email, folderRole: TYPE })}
            >
              <Icon src="check" />
              {data.VIEWER.TYPE === TYPE && <span>{t('folder.role.viewer.description')}</span>}
              {data.EDITOR.TYPE === TYPE && <span>{t('folder.role.editor.description')}</span>}
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default Select;
